import { API_URL, Support_API_TOKEN, ENV } from '../../config';

const fetchSupportByURL = async (url: string, lang: string) => {
    try {
        let langpart = '';
        if (lang.indexOf('zh') > -1) {
          langpart = "&locale=zh-Hant-HK";
        }
        url = url + langpart;
        if (ENV === 'preproduction') {
          url += url.indexOf('?') > -1 ? '&publicationState=preview' : '?publicationState=preview';
        }
        console.log('Fetching URL:', url);
        const response = await fetch(url, { headers: { Authorization: `Bearer ${Support_API_TOKEN}` } });
        if (!response.ok) {
          console.error(`Error fetching Support: ${ url +" , " +response.statusText}`);
          return null;
        }

        const support = await response.json();
        console.log('API Response:', support);

        return support;
    } catch (error) {
        console.error('Error fetching with URL', url, error);
        return null;
    }
}
export const fetchSupport = async (lang: string) => {
    let url = `${API_URL}/support?pagination[limit]=-1&populate=posts_with_image.FeaturedImage,topics.FeaturedImage,posts_with_descriptions.FeaturedImage,freq_group.SupportArticles,suggested_topics.FeaturedImage,contact_us_icon,SEO.MetaImage,GA`;
    const supportData = await fetchSupportByURL(url,lang);
    return supportData;

};

export const fetchSupportItems = async (lang: string) => {
  let url = `${API_URL}/support-articles?pagination[limit]=-1&populate=FAQQuestions,FeaturedImage,Content.Links,Content.Items.Link.FeaturedImage,Content.LargeImage,Content.AppIcon1,Content.AppIcon2,Content.AppIcon3,Content.AccordionItem,Content.Icon,Content.SliderItem.Image,Content.Articles,Content.Image,Content.ExternalLink,Content.DropdownItems.DropdownContent.SliderItem.Image,Content.DropdownItems.DropdownContent.Image,Content.DropdownItems.AccordionItem,Content.TabItems.TabContent.SliderItem.Image,Content.TabItems.TabContent.Image,Content.TabItems.TabContent.AccordionItem,Parent.Parent.Parent.Parent.Parent.Parent.Parent.Parent.Parent.Parent,SEO.MetaImage,GA`;
  const supportItemData = await fetchSupportByURL(url,lang);
  return supportItemData;
  
};

export const fetchSupportArticleName = async () => {
  let url = `${API_URL}/support-articles?pagination[limit]=-1`;
  const supportAllDataEn = await fetchSupportByURL(url,"en");
  const supportAllDataZh = await fetchSupportByURL(url,"zh");
  const result = [];
  supportAllDataEn.data.forEach(element => {
    result.push({"name":element.attributes.Name});
  });
  supportAllDataZh.data.forEach(element => {
    result.push({"name":element.attributes.Name});
  });
  return result;
}

export const fetchSupportSearchResult = async (lang:string, keyword: string) => {
  let url1 = `${API_URL}/support-articles?filters[$or][0][Name][$containsi]=`+keyword+`&filters[$or][1][description][$containsi]=`+keyword;
  let url2 = `${API_URL}/support-articles?pagination[limit]=-1`;
  const supportSearchResultDataEn = await fetchSupportByURL(url1,"en");
  const supportSearchResultDataZh = await fetchSupportByURL(url1,"zh");
  const supportAllDataEn = await fetchSupportByURL(url2,"en");
  const supportAllDataZh = await fetchSupportByURL(url2,"zh");

  const allEnData = mergeData(supportSearchResultDataEn, supportAllDataZh, lang);
  const allZhData = mergeData(supportSearchResultDataZh, supportAllDataEn, lang);
  
  const mergedArray = [...allEnData, ...allZhData];
  const uniqueMap = new Map();

  for (const item of mergedArray) {
    uniqueMap.set(item.slug, item);
  }

  return [...uniqueMap.values()];
}

const mergeData = (supportSearchResultData: any, supportAllData: any, lang: string) => {
  const allResultData: { nameEn: string; nameZh: string; slug: string; category: any; }[] = [];

  supportSearchResultData?.data.forEach((result: { attributes: { slug: any; Categories: any; Name: any; }; }) => {
    let matched = null;

    if (supportAllData?.data && Array.isArray(supportAllData.data)) {
      supportAllData.data.forEach((all: { attributes: { slug: any; }; }) => {
        if (result.attributes.slug == all.attributes.slug) {
          matched = all;
        }
      });
    }
    const chineseRegex = /[\u4e00-\u9fa5]/;

    const name = matched ? matched.attributes.Name : "";
    const category = lang == "en" ? (chineseRegex.test(result.attributes.Name) ? matched?.attributes.Categories : result.attributes.Categories) : (chineseRegex.test(result.attributes.Name) ? result.attributes.Categories : matched?.attributes.Categories);

    allResultData.push({
      "nameEn": chineseRegex.test(result.attributes.Name) ? name : result.attributes.Name,
      "nameZh": chineseRegex.test(name) ? name : result.attributes.Name,
      "slug": result.attributes.slug,
      "category": category ? category : ["Uncategorized"]
    });
  });

  return allResultData;
}